import React from 'react';
import { Box } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const campaignImage = `https://${window.location.host}/images/share-image.png`;

const Settings = () => {
    return (
        <Box p={5} mx="auto">
            <Helmet>
                <title>Settings - PurelyGive</title>
                <meta name="description" content="Configure your PurelyGive account settings, notifications, and preferences. Tailor your experience to suit your needs." />
                <meta name="keywords" content="settings, account preferences, notifications, configurations, PurelyGive" />
                <meta property="og:title" content="Account Settings - PurelyGive" />
                <meta property="og:description" content="Adjust your account settings and preferences to optimize your experience on PurelyGive." />
                <meta property="og:image" content={campaignImage} />
                <meta property="og:url" content="https://purelygive.com/settings" />
            </Helmet>
            <Link to="/withdrawals/create">X- Start a new withdrawal -X</Link><br /><br />
            <Link to="/settings/bank">X- v1 Add a bank account -X</Link><br /><br />
            <Link to="/info/email">X- Update organization Email -X</Link><br /><br />
        </Box>
    );
};

export default Settings;
